import React from 'react'

const Package = () => {
  return (
    <div>Package</div>
  )
}

export default Package